import styled from 'styled-components';

export const Container = styled.div`
height: 100%;
`;

export const Scroll = styled.div`
overflow-y: scroll;
`;